export default [
  {
    fieldName: 'Notes',
    isRequired: false,
    label: 'Notes',
    type: 'textarea'
  }
];



// WEBPACK FOOTER //
// ./src/formFields/notes.tsx